import { useState } from "react";

type LpAnnouncement = {
  id: number;
  announce_at: string;
  title: string;
  content: string;
  heading: string;
  prioritizes: boolean;
};

const useAnnouncementModal = () => {
  const [selectedAnnouncement, setSelectedAnnouncement] = useState<LpAnnouncement | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (announcement: LpAnnouncement) => {
    if (announcement.content) {
      setSelectedAnnouncement(announcement);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setSelectedAnnouncement(null);
    setIsModalOpen(false);
  };

  return {
    selectedAnnouncement,
    isModalOpen,
    openModal,
    closeModal,
  };
};

export default useAnnouncementModal;
